export default __webpack_public_path__ + "static/media/folder-20-px.08946439.svg";